// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Financial Period Filters Styles
 * Enhanced styles for the financial period filters component
 */

.financial-period-filters {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 24px;
  overflow: hidden;
}

.filters-form {
  display: flex;
  flex-direction: column;
}

.filters-content {
  padding: 24px;
}


.filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e9ecef;
}

.filters-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.active-filters-count {
  display: inline-block;
  background: #0D3B66;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  margin-left: auto;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-group label {
  font-weight: 600;
  color: #495057;
  font-size: 0.875rem;
  margin-bottom: 4px;
}

.filter-group input,
.filter-group select {
  padding: 12px 16px;
  border: 1px solid #ced4da;
  border-radius: 8px;
  font-size: 0.875rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  background: white;
}

.filter-group input:focus,
.filter-group select:focus {
  outline: none;
  border-color: #0D3B66;
  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);
}

.filter-group input:disabled,
.filter-group select:disabled {
  background: #e9ecef;
  cursor: not-allowed;
}

/* Filter Group Styles */
.filters-grid .filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Active Filters Summary */
.active-filters-summary {
  background: #e3f2fd;
  border-top: 1px solid #bbdefb;
  padding: 16px 24px;
}

.summary-header {
  margin-bottom: 12px;
}

.summary-title {
  font-weight: 600;
  color: #0D3B66;
  font-size: 0.875rem;
}

.active-filters-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.active-filter-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #0D3B66;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8125rem;
  font-weight: 500;
}

.remove-filter {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  padding: 0;
  margin-left: 4px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.remove-filter:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Button Styles */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-outline {
  background: white;
  color: #0D3B66;
  border-color: #0D3B66;
}

.btn-outline:hover:not(:disabled) {
  background: #0D3B66;
  color: white;
  border-color: #0D3B66;
}

.btn-secondary {
  background: #6c757d;
  color: white;
  border-color: #6c757d;
}

.btn-secondary:hover:not(:disabled) {
  background: #5a6268;
  border-color: #545b62;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .filters-grid {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .filters-content {
    padding: 16px;
  }

  .filters-grid {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 12px;
    padding: 16px;
  }

  .filters-actions {
    justify-content: center;
    gap: 12px;
  }

  .btn {
    padding: 8px 12px;
    font-size: 0.8125rem;
  }

  .active-filters-summary {
    padding: 12px 16px;
  }
}

@media (max-width: 480px) {
  .financial-period-filters {
    margin-bottom: 16px;
  }

  .filters-content {
    padding: 12px;
  }

  .filters-grid {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 12px;
  }

  .filter-group input,
  .filter-group select {
    padding: 10px 12px;
    font-size: 0.8125rem;
  }

  .filters-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .active-filters-count {
    margin-left: 0;
    text-align: center;
  }

  .active-filters-summary {
    padding: 10px 12px;
  }

  .active-filter-tag {
    font-size: 0.75rem;
    padding: 4px 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/financial/FinancialPeriodFilters.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,wDAAwD;EACxD,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,2DAA2D;IAC3D,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,2DAA2D;IAC3D,SAAS;IACT,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;;EAEA;;IAEE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF","sourcesContent":["/**\n * Financial Period Filters Styles\n * Enhanced styles for the financial period filters component\n */\n\n.financial-period-filters {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  margin-bottom: 24px;\n  overflow: hidden;\n}\n\n.filters-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.filters-content {\n  padding: 24px;\n}\n\n\n.filters-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 24px;\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 12px;\n  border: 1px solid #e9ecef;\n}\n\n.filters-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.active-filters-count {\n  display: inline-block;\n  background: #0D3B66;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-left: auto;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.filter-group label {\n  font-weight: 600;\n  color: #495057;\n  font-size: 0.875rem;\n  margin-bottom: 4px;\n}\n\n.filter-group input,\n.filter-group select {\n  padding: 12px 16px;\n  border: 1px solid #ced4da;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  background: white;\n}\n\n.filter-group input:focus,\n.filter-group select:focus {\n  outline: none;\n  border-color: #0D3B66;\n  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);\n}\n\n.filter-group input:disabled,\n.filter-group select:disabled {\n  background: #e9ecef;\n  cursor: not-allowed;\n}\n\n/* Filter Group Styles */\n.filters-grid .filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Active Filters Summary */\n.active-filters-summary {\n  background: #e3f2fd;\n  border-top: 1px solid #bbdefb;\n  padding: 16px 24px;\n}\n\n.summary-header {\n  margin-bottom: 12px;\n}\n\n.summary-title {\n  font-weight: 600;\n  color: #0D3B66;\n  font-size: 0.875rem;\n}\n\n.active-filters-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.active-filter-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #0D3B66;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.8125rem;\n  font-weight: 500;\n}\n\n.remove-filter {\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: bold;\n  padding: 0;\n  margin-left: 4px;\n  width: 16px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n}\n\n.remove-filter:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* Button Styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-outline {\n  background: white;\n  color: #0D3B66;\n  border-color: #0D3B66;\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: #0D3B66;\n  color: white;\n  border-color: #0D3B66;\n}\n\n.btn-secondary {\n  background: #6c757d;\n  color: white;\n  border-color: #6c757d;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: #5a6268;\n  border-color: #545b62;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .filters-grid {\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .filters-content {\n    padding: 16px;\n  }\n\n  .filters-grid {\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n    gap: 12px;\n    padding: 16px;\n  }\n\n  .filters-actions {\n    justify-content: center;\n    gap: 12px;\n  }\n\n  .btn {\n    padding: 8px 12px;\n    font-size: 0.8125rem;\n  }\n\n  .active-filters-summary {\n    padding: 12px 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .financial-period-filters {\n    margin-bottom: 16px;\n  }\n\n  .filters-content {\n    padding: 12px;\n  }\n\n  .filters-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n    padding: 12px;\n  }\n\n  .filter-group input,\n  .filter-group select {\n    padding: 10px 12px;\n    font-size: 0.8125rem;\n  }\n\n  .filters-actions {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .active-filters-count {\n    margin-left: 0;\n    text-align: center;\n  }\n\n  .active-filters-summary {\n    padding: 10px 12px;\n  }\n\n  .active-filter-tag {\n    font-size: 0.75rem;\n    padding: 4px 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
